export function fetchLink(block, recordMap) {
    var parent = recordMap.collection[block.parent_id];
    if (!parent)
        return { isLink: false, link: block.id, target: '_self' };
    // go through parent schema
    for (var sk in parent.value.schema) {
        var sku = parent.value.schema[sk];
        if (/^simple:link$/i.test(sku.name)) {
            var properties = block.properties;
            var link = properties ? properties[sk][0][0] : null;
            return { isLink: !!link, link: link, target: '_self' };
        }
        else if (/^simple:link_$/i.test(sku.name)) {
            var properties = block.properties;
            var link = properties ? properties[sk][0][0] : null;
            return { isLink: !!link, link: link, target: '_blank' };
        }
        return { isLink: false, link: block.id, target: '_self' };
    }
}
export function parseImage(caption) {
    var data = { isLink: false, data: null };
    if (/\[\[.*\]\]/.test(caption)) {
        var url = caption.match(/\[\[(.*)\]\]/)[1];
        data.isLink = true;
        data.data = { href: url, target: '_blank', rel: 'noreferrer' };
    }
    else if (/\[.*\]/.test(caption)) {
        var url = caption.match(/\[(.*)\]/)[1];
        data.isLink = true;
        data.data = { href: url };
    }
    return data;
}
//# sourceMappingURL=embed.js.map